import React, { useContext } from 'react'
import { Link } from 'gatsby'
import { getImage, GatsbyImage } from 'gatsby-plugin-image'
import slugify from 'slugify'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import FontContext from '../context/fontsize/fontContext'

const useStyles = makeStyles((theme) => ({
	outerCtr: {
		paddingLeft: 100,
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 50,
		},
		[theme.breakpoints.down('xs')]: {
			padding: '2em 24px',
		},
	},
	title: {
		color: theme.palette.common.accent,
		// color: 'red',
		fontSize: '1rem',
		fontWeight: 700,
		[theme.breakpoints.up('sm')]: {
			fontWeight: 500,
		},
	},
	lightTitle: {
		color: theme.palette.common.accent,
		fontSize: '1rem',
		fontWeight: 700,
		[theme.breakpoints.up('sm')]: {
			fontWeight: 500,
		},
	},
	shortTitle: {
		color: 'lightgrey',
	},
	lightShortTitle: {
		color: 'rgba(117, 117, 117, 1)',
	},
	tags: {
		color: 'grey',
		fontSize: '.8rem',
		marginBottom: 3,
		textDecoration: 'none',
		fontWeight: 400,
		textTransform: 'uppercase',
	},
	lightTags: {
		color: '#292929',
		fontSize: '.8rem',
		marginBottom: 3,
		fontWeight: 400,
		textDecoration: 'none',
		textTransform: 'uppercase',
	},
	date: {
		color: 'lightgrey',
		fontSize: '.8rem',
	},
	lightDate: {
		color: '#757575',
		fontSize: '.8rem',
	},
	gatsImage: {
		[theme.breakpoints.down('xs')]: {
			width: 100,
		},
	},
}))

const PostsList = ({ title = 'Posts', posts }) => {
	const classes = useStyles()
	const fontContext = useContext(FontContext)
	const { darkMode } = fontContext

	return (
		<Grid container>
			<Grid item>
				<Grid container direction='column' spacing={3}>
					<Grid item xs={12} lg={12}>
						<Typography variant='h6' style={{ textTransform: 'capitalize' }}>
							{title}
						</Typography>
						<Divider />
					</Grid>
					{posts.map((post) => {
						const image = getImage(post.image)
						const slug = slugify(post.title, { lower: true })

						return (
							<Grid
								item
								key={post.id}
								style={{ paddingTop: 12, paddingBottom: 12 }}
							>
								<Grid container direction='row'>
									<Grid item xs={9} lg={9}>
										<Grid
											container
											direction='column'
											alignItems='flex-start'
											style={{ height: '100%' }}
										>
											<Grid
												container
												alignItems='flex-start'
												style={{ height: '50%' }}
											>
												<Grid item xs={12} lg={12}>
													<Link
														to={`/articles/${slug}`}
														style={{
															textDecoration: 'none',
															color: darkMode ? '#4ecca3' : '#00a66e',
														}}
													>
														<Typography
															variant='h6'
															className={
																darkMode ? classes.title : classes.lightTitle
															}
														>
															{post.title}
														</Typography>
													</Link>
												</Grid>
												<Grid item xs={11} sm={12} lg={12}>
													<Link
														to={`/articles/${slug}`}
														style={{
															textDecoration: 'none',
														}}
													>
														<Typography
															variant='subtitle1'
															className={
																darkMode
																	? classes.shortTitle
																	: classes.lightShortTitle
															}
														>
															{post.shortTitle}
														</Typography>
													</Link>
												</Grid>
											</Grid>
											<Grid
												container
												alignItems='flex-end'
												style={{ height: '50%' }}
											>
												<Grid item xs={12} lg={12}>
													{/* <Typography
													variant='subtitle2'
													className={
														darkMode ? classes.tags : classes.lightTags
													}
												>
													{cats.split(',').join(' | ').toUpperCase()}
												</Typography> */}
													{post.tags.tags.map((cat, i) => {
														const slug = slugify(cat, { lower: true })

														return (
															<Link
																to={`/articles/categories/${slug}`}
																key={i}
																className={
																	darkMode ? classes.tags : classes.lightTags
																}
															>
																<span>
																	{i !== 0 && ' | '}
																	{cat}{' '}
																</span>
															</Link>
														)
													})}

													<Link
														to={`/articles/${slug}`}
														style={{
															textDecoration: 'none',
														}}
													>
														<Typography
															variant='subtitle1'
															className={
																darkMode ? classes.date : classes.lightDate
															}
														>
															{post.createdAt} -{' '}
															{Math.round(
																post.body.body.split(' ').length / 200
															)}{' '}
															min read
														</Typography>
													</Link>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
									<Grid item xs={3} lg={3}>
										<Grid
											container
											justify='flex-end'
											alignItems='center'
											style={{ minHeight: '100%' }}
										>
											{/* <img
                    src={testimg}
                    alt='test'
                    style={{ width: 152, height: 122 }}
                  /> */}
											<Link
												to={`/articles/${slug}`}
												style={{
													textDecoration: 'none',
												}}
											>
												<GatsbyImage
													image={image}
													imgClassName={classes.gatsImage}
													alt={post.title}
												/>
											</Link>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						)
					})}
				</Grid>
			</Grid>
		</Grid>
	)
}

export default PostsList
